(() => {
  const WHOLESALE_HANDLE = '/products/wholesale-0-33-fl-oz-perfume-oil-roll-on-unit';
  const WHOLESALE_PAGE = '/pages/wholesale';
  const MINIMUM_UNITS = 40;

  if (window.location.pathname === WHOLESALE_HANDLE) {
    window.location.replace(WHOLESALE_PAGE);
    return;
  }

  let checking = false;

  const wholesaleQuantity = (cart) => (cart.items || []).reduce((sum, item) => {
    const properties = item.properties || {};
    return properties._Wholesale === 'true' ? sum + Number(item.quantity || 0) : sum;
  }, 0);

  const removeNotices = () => {
    document.querySelectorAll('[data-aw-wholesale-guard-notice]').forEach((node) => node.remove());
  };

  const showNotice = (button, quantity) => {
    const remaining = Math.max(0, MINIMUM_UNITS - quantity);
    const notice = document.createElement('p');
    notice.setAttribute('data-aw-wholesale-guard-notice', '');
    notice.style.margin = '0 0 12px';
    notice.style.padding = '11px 13px';
    notice.style.border = '1px solid #cdbb9d';
    notice.style.background = '#faf8f4';
    notice.style.color = '#514738';
    notice.style.fontSize = '12px';
    notice.style.lineHeight = '1.5';
    notice.style.textAlign = 'center';
    notice.textContent = 'Wholesale minimum: 40 roll-ons ($200). Add ' + remaining + ' more roll-on' + (remaining === 1 ? '' : 's') + ' before checkout.';
    button.parentElement?.insertBefore(notice, button);
  };

  const lockCheckout = (quantity) => {
    removeNotices();
    const locked = quantity > 0 && quantity < MINIMUM_UNITS;
    const buttons = [...document.querySelectorAll('button[name="checkout"], input[name="checkout"]')];

    buttons.forEach((button) => {
      if (locked) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.awWholesaleLocked = 'true';
        showNotice(button, quantity);
      } else if (button.dataset.awWholesaleLocked === 'true') {
        delete button.dataset.awWholesaleLocked;
        button.removeAttribute('aria-disabled');
        const terms = button.hasAttribute('data-terms-action');
        const termsChecked = document.querySelector('input[name="agree_terms"]:checked');
        if (!terms || termsChecked) button.disabled = false;
      }
    });

    document.querySelectorAll('.additional-checkout-buttons').forEach((box) => {
      if (locked) {
        if (!box.hasAttribute('data-aw-wholesale-hidden')) {
          box.dataset.awWholesaleHidden = 'true';
          box.hidden = true;
        }
      } else if (box.dataset.awWholesaleHidden === 'true') {
        delete box.dataset.awWholesaleHidden;
        box.hidden = false;
      }
    });

    document.documentElement.dataset.awWholesaleLocked = locked ? 'true' : 'false';
  };

  const check = async () => {
    if (checking) return;
    checking = true;
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      lockCheckout(wholesaleQuantity(cart));
    } catch (error) {
    } finally {
      checking = false;
    }
  };

  document.addEventListener('DOMContentLoaded', check);
  document.addEventListener('cart:updated', () => setTimeout(check, 40));
  document.addEventListener('product-ajax:added', () => setTimeout(check, 40));
  document.addEventListener('change', (event) => {
    if (event.target?.matches?.('input[name="agree_terms"]')) setTimeout(check, 0);
  });

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (submitter?.name === 'checkout' && document.documentElement.dataset.awWholesaleLocked === 'true') {
      event.preventDefault();
      event.stopPropagation();
      check();
    }
  }, true);

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest?.('[name="checkout"]');
    if (checkout && document.documentElement.dataset.awWholesaleLocked === 'true') {
      event.preventDefault();
      event.stopPropagation();
      check();
    }
  }, true);
})();
